import { render, staticRenderFns } from "./GlobalWait.vue?vue&type=template&id=2ffd0bd9&scoped=true&"
import script from "./GlobalWait.vue?vue&type=script&lang=js&"
export * from "./GlobalWait.vue?vue&type=script&lang=js&"
import style0 from "./GlobalWait.vue?vue&type=style&index=0&id=2ffd0bd9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd0bd9",
  null
  
)

export default component.exports